module.exports = __webpack_public_path__ + "static/media/features-ic-06.da9db1bb.svg";